var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.258,
    height: 9.831,
    viewBox: "0 0 14.258 9.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_001-arrow-down-sign-to-navigate",
    "data-name": "001-arrow-down-sign-to-navigate",
    transform: "translate(-0.001 -97.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M7.13,106.972a.916.916,0,0,1-.706-.354L.293,99.2a1.393,1.393,0,0,1,0-1.708.882.882,0,0,1,1.412,0l5.424,6.562,5.425-6.562a.881.881,0,0,1,1.412,0,1.393,1.393,0,0,1,0,1.708l-6.131,7.416A.916.916,0,0,1,7.13,106.972Z",
    transform: "translate(0)",
    fill: "#00868e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBar);
export default __webpack_public_path__ + "static/media/navBar.ff44a8621ca9ae3324a9e0e613ea02f8.svg";
export { ForwardRef as ReactComponent };